import { cartJson } from "./liquidInit"

export function localStorageIsAvailable() {
  console.warn("[Is Local Storage Available]")
  let storage
  try {
    storage = window.localStorage
    const x = "__storage_test__"
    storage.setItem(x, x)
    storage.removeItem(x)
    console.warn("[Local Storage Available]")
    return true
  } catch (e) {
    console.warn("[Local Storage Not Available]")
    return (
      e instanceof DOMException &&
      // everything except Firefox
      (e.code === 22 ||
        // Firefox
        e.code === 1014 ||
        // test name field too, because code might not be present
        // everything except Firefox
        e.name === "QuotaExceededError" ||
        // Firefox
        e.name === "NS_ERROR_DOM_QUOTA_REACHED") &&
      // acknowledge QuotaExceededError only if there's something already stored
      storage &&
      storage.length !== 0
    )
  }
}

/**
 * Saves passed cart object to local storage
 * @param {Object} cart
 */
export function updateCartLocalStorage(cart) {
  console.warn("[Set Local Storage]")
  if (window._fsaLocalStorageIsAvailable) {
    localStorage.setItem("cart", JSON.stringify(cart))
  } else {
    console.warn("[No Local Storage]")
  }
}

export function getLocalStorageCart() {
  console.warn("[Get Local Storage]")
  if (window._fsaLocalStorageIsAvailable) {
    const localStorageCart = localStorage.getItem("cart")
    const cart = JSON.parse(localStorageCart)
    return cart
  }
  console.warn("[No Local Storage]")
  return null
}

export function updateLocalStorageIfNewOrChanged() {
  console.warn("[Update Local Storage If New Or Changed]")
  if (window._fsaLocalStorageIsAvailable) {
    const localCart = getLocalStorageCart()
    const currentCart = cartJson

    if (JSON.stringify(localCart) !== JSON.stringify(currentCart)) {
      console.warn("[Cart Change Detected Onload]")
      updateCartLocalStorage(cartJson)
    }
  } else {
    console.warn("[No Local Storage]")
  }
}
